import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { PreventToolbarHiddenContext } from './PreventToolbarHiddenContext';

export interface PreventHiddenToolbarProps {
  preventToolbarHidden?: boolean;
}

export const withPreventHiddenToolbar = (Component) => {
  const ResponseComponent = (props) => {
    const [preventHidden, setPreventHidden] = React.useState(false);

    return (
      <PreventToolbarHiddenContext.Provider
        value={{
          preventToolbarHidden: preventHidden,
          setPreventToolbarHidden: setPreventHidden,
        }}
      >
        <Component {...props} preventToolbarHidden={preventHidden} />
      </PreventToolbarHiddenContext.Provider>
    );
  };

  hoistNonReactStatic(ResponseComponent, Component);

  return ResponseComponent;
};
